import { CompletionDesignBase } from './base/completion-design-base';

export class CompletionDesign extends CompletionDesignBase { }